/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchUserPlaylistsResponsePlaylists,
  FetchUserPlaylistsResponsePlaylistsFromJSON,
  FetchUserPlaylistsResponsePlaylistsToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchUserPlaylistsResponse
 */
export interface FetchUserPlaylistsResponse {
  /**
   * List of playlists owned by and shared with the user, ordered by creation date (newest first)
   * @type {Array<FetchUserPlaylistsResponsePlaylists>}
   * @memberof FetchUserPlaylistsResponse
   */
  playlists: Array<FetchUserPlaylistsResponsePlaylists>
  /**
   * Total count of owned and shared playlists, including BC/LC playlists already created.
   * @type number
   * @memberof FetchUserPlaylistsResponse
   */
  totalCount: number
}

export function FetchUserPlaylistsResponseFromJSON(
  json: any
): FetchUserPlaylistsResponse {
  return FetchUserPlaylistsResponseFromJSONTyped(json, false)
}

export function FetchUserPlaylistsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchUserPlaylistsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlists: (json['playlists'] as Array<any>).map(
      FetchUserPlaylistsResponsePlaylistsFromJSON
    ),
    totalCount: json['totalCount'],
  }
}

export function FetchUserPlaylistsResponseToJSON(
  value?: FetchUserPlaylistsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlists: (value.playlists as Array<any>).map(
      FetchUserPlaylistsResponsePlaylistsToJSON
    ),
    totalCount: value.totalCount,
  }
}
